import { cn } from '@/lib/utils';

interface BrandLogoProps {
  className?: string;
  variant?: 'full' | 'compact';
}

/** Full artwork for light surfaces; a horizontal lockup for the dark sidebar. */
export function BrandLogo({ className, variant = 'full' }: BrandLogoProps) {
  const source = `${import.meta.env.BASE_URL}nissei-logo.png`;

  if (variant === 'compact') {
    return (
      <span className={cn('flex min-w-0 items-center gap-3', className)}>
        {/* Display just the original symbol, preserving its colors and proportions. */}
        <svg
          viewBox="124 0 112 96"
          width={40}
          height={40}
          aria-hidden="true"
          focusable="false"
          className="shrink-0 overflow-hidden rounded-field bg-white"
        >
          <image href={source} width={352} height={142} />
        </svg>
        <span className="flex flex-col gap-0.5 whitespace-nowrap">
          <span className="text-[15px] font-semibold leading-5 tracking-wide text-white">Nissei USA</span>
          <span className="text-[9px] uppercase leading-3 tracking-[0.18em] text-on-dark-70">Corporation</span>
        </span>
      </span>
    );
  }

  return (
    <img
      src={source}
      alt="Nissei USA Corporation"
      width={352}
      height={142}
      className={cn('block h-auto max-w-full shrink-0', className)}
    />
  );
}
